var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No LPT"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 16",
    cx: 20.5003,
    cy: 10.3031,
    rx: 13.3333,
    ry: 4.84848,
    stroke: "#5663F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 17",
    d: "M7.16699 20C7.16699 22.6777 13.1365 24.8485 20.5003 24.8485C22.9933 24.8485 25.3264 24.5997 27.3223 24.1667",
    stroke: "#5663F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    d: "M7.16699 10.6158V29.697C7.16699 32.3747 13.1365 34.5455 20.5003 34.5455C22.9289 34.5455 25.2058 34.3094 27.167 33.8968M33.8337 10.6158V16.6667",
    stroke: "#5663F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M33.833 23.3334L33.833 30",
    stroke: "#5663F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 33.8337,
    cy: 35,
    r: 1.66667,
    fill: "#5663F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLpt);
export default __webpack_public_path__ + "static/media/NoLPT.7658f3870b6ad422e4fc99b4d8f66edb.svg";
export { ForwardRef as ReactComponent };